import { useTranslation } from 'next-i18next';
import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';
const data = [
  {
    title: 'Step 1',
    desc: 'Sign up in under 60 seconds.',
  },
  {
    title: 'Step 2',
    desc: 'Get your unique referral links and spread the word.',
  },
  {
    title: 'Step 3',
    desc: 'Start earning big!',
  },
];
const line = (
  <svg width="54" height="12" viewBox="0 0 54 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M53.7734 6L48 11.7734L43.2266 7L11.2383 7C10.7701 9.4674 8.60363 11.333 6 11.333C3.05448 11.333 0.666991 8.94552 0.666992 6C0.666992 3.05448 3.05448 0.666992 6 0.666993C8.60363 0.666993 10.7701 2.53261 11.2383 5L43.2266 5L48 0.226567L53.7734 6Z"
      fill="#D9D9D9"
    />
  </svg>
);

export default function Steps() {
  const { t } = useTranslation('common');
  return (
    <div className="lg:py-20 py-10 lg:px-0 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="lg:text-5xl text-3xl font-bold text-gray-900 text-center mb-4">{t('Get started in minutes')}</h2>
        <p className="lg:text-lg text-base text-gray-500 text-center lg:w-[600px] w-full mx-auto">
          {t(
            'Signing up is quick and easy. Once you join, you’ll get everything you need to start sharing and earning.'
          )}
        </p>

        <div className="grid lg:grid-cols-3 grid-cols-1 gap-4 lg:mt-14 mt-7">
          {data.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl border border-gray-200 shadow p-8 relative">
              <div className="text-2xl font-bold text-gray-900 mb-4">{t(item.title)}:</div>
              <div className="w-[30px] h-[5px] bg-[#725CFF] mb-4"></div>
              <h3 className="text-gray-500">{t(item.desc)}</h3>
              {index == 0 && <div className="absolute top-4 -right-9 z-10 lg:block hidden">{line}</div>}
              {index == 1 && <div className="absolute bottom-4 -right-9 z-10 lg:block hidden">{line}</div>}
            </div>
          ))}
        </div>
        <div
          className="lg:w-[300px] w-full h-[40px] flex rounded-full items-center justify-center cursor-pointer  lg:mt-14 mt-7 bg-[#725CFF] text-white mx-auto"
          onClick={() => {
            ga_logEvent(EventName.affiliate_apply_click);
            window.open(
              'https://dolphin-radar.getrewardful.com/signup?campaign=dolphinradar-affiliate-user-30',
              '_blank'
            );
          }}
        >
          {t('Apply Now')}
        </div>
      </div>
    </div>
  );
}
